
import React , { useState } from "react";
import logo from "../../assets/web/images/logo.png";
import appStore from "../../assets/web/images/app-store-1.png";
import playStore from "../../assets/web/images/play-store-2.png";
import { Link , NavLink  } from "react-router-dom";

const  FooterHome = (props) => {
  return (
    <>
       <footer className="ivo-section ivo-footer">
        <div className="container">
            <div className="row">
                <div className="col-lg-2 col-md-6 col-sm-6 mb-3">
                    <div className="ivo-footer-logo">
                        <img className="img-fluid" src={logo} alt="logo" />
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 mb-3">
                    <div className="ivo-ftco-footer-widget ">
                        <h4 className="mb-3">Services</h4>
                        <ul className="ivo-footer-ul">

                            <li><Link to="/download" className="py-1 d-block">Download</Link></li>
                            {/* <li><Link href="" className="py-1 d-block">Careers</Link></li> */}
                            <li><Link to="/contact" className="py-1 d-block">Contact Us</Link></li>



                        </ul>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 mb-3">
                    <div className="ivo-ftco-footer-widget ">
                        <h4 className="mb-3">Support</h4>
                        <ul className="ivo-footer-ul">

                            <li><Link to="/help" className="py-1 d-block">Help Center</Link></li>
                            <li><Link to="/terms-and-conditions" className="py-1 d-block">Terms Of Use</Link></li>
                            <li><Link to="/privacy-policy" className="py-1 d-block">Privacy Policy</Link></li>



                        </ul>
                    </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-6 mb-3">
                    <div className="footer-icons  ">
                        <h4 className="mb-3">Follow Us</h4>
                        <ul className="footer-icon-box">

                            <li>
                                <Link href=""><i className="f-icons fa-brands fa-facebook-f f-block"></i></Link>
                            </li>
                            <li>
                                <Link href=""><i className="f-icons f-block fa-brands fa-twitter"></i></Link>
                            </li>
                            <li>
                                <Link href=""><i className="f-icons f-block fa-brands fa-youtube"></i></Link>
                            </li>
                            <li>
                                <Link href=""><i className="f-icons f-block fa-brands fa-instagram"></i></Link>
                            </li>
                            <li>
                                <Link href=""><i className="f-icons f-block fa-brands fa-linkedin-in"></i></Link>
                            </li>




                        </ul>

                        <div className="mt-2 d-flex">
                            <Link className="mr-2" to="/download"  ><img src={appStore} alt="" /></Link> <Link to="/download" ><img src={playStore} alt="" /></Link>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
        </div>
        <div className="ivo-bottom-footer  ">
            <p className="ivo-para">© IVOIRE. All rights reserved</p>
        </div>



    </footer>
    </>

  );
}

export default FooterHome;
